export default "__VITE_ASSET__2ec3e40a__"